const checkValueExistence = (value) => {
    try {
        value = JSON.parse(value);
    } catch (e) {
        value = value
    }

    if(value) {
        if (value instanceof Array) {
            return value.length > 0;
        } else {
            try {
                return Boolean(value.toString().trim());
            } catch(e){
                console.error(e)
                return false
            }
        }
    }
    return false
}
module.exports.checkValueExistence = checkValueExistence